export const getQueryVariable = variable => {
  const query = global.location?.search?.substring(1) || ''
  const vars = query.split('&')
  let i = 0

  for (i; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return false
}

export const getQueryParamFromUrl = (
  hrefString: string,
  queryParam: string
) => {
  const hrefParts = hrefString.split('?')
  const searchString = hrefParts[hrefParts.length - 1]

  return getQueryParamFromSearchString(searchString, queryParam)
}

const getQueryParamFromSearchString = (
  searchString: string,
  queryParam: string
) => {
  const searchParams = new URLSearchParams(searchString)
  return searchParams.get(queryParam)
}

export const updateQueryParamWithoutReload = (queryParam, value) => {
  const url = new URL(location.href)
  url.searchParams.set(queryParam, value)
  global.history.pushState(null, null, url)
}

export const setUrl = url => {
  global.location.href = url
}

const DOMAIN_REGEX = /^([A-z])+\.com\.br$/
const ENGINEERING_DOMAIN_REGEX = /^([A-z])+\.engineering$/
const STAGING_DOMAIN_REGEX = /^staging\.([A-z])+\.com\.br$/
export const getDomain = () => {
  const hostname = global.location?.hostname || ''
  const hostnameParts = hostname.split('.')
  if (
    DOMAIN_REGEX.test(hostname) ||
    ENGINEERING_DOMAIN_REGEX.test(hostname) ||
    STAGING_DOMAIN_REGEX.test(hostname) ||
    hostnameParts.length <= 1
  ) {
    return hostname
  }

  return hostnameParts.slice(1).join('.')
}

export const getQueryStringValue = (key: string) => {
  return decodeURIComponent(
    (window.location?.search || '').replace(
      new RegExp(
        '^(?:.*[&\\?]' +
          encodeURIComponent(key).replace(/[.+*]/g, '\\$&') +
          '(?:\\=([^&]*))?)?.*$',
        'i'
      ),
      '$1'
    )
  )
}

export default {
  getQueryVariable,
  set: setUrl,
  getDomain,
  updateQueryParamWithoutReload,
  getQueryStringValue
}
